"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const react_redux_1 = require("react-redux");
const alchemy_ui_1 = require("@m/alchemy-ui");
const LoadableBlock_1 = require("@mdigital/components/dist/components/LoadableBlock");
const utils_1 = require("../../../common/utils");
const HttpManager_1 = __importDefault(require("../../../services/HttpManager"));
const api_1 = require("../../../common/api");
const ProviderHoc_1 = __importDefault(require("../../hoc/ProviderHoc"));
const styled_1 = require("./styled");
const DomainsConfiguration_1 = require("./DomainsConfiguration");
const TextPathPrefix = 'app.pages.administration.domainsList';
const SaveNotification = `${TextPathPrefix}.domainSavedNotification`;
const Title = `${TextPathPrefix}.title`;
const Save = `${TextPathPrefix}.save`;
const DomainSaveError = `${TextPathPrefix}.domainSaveError`;
const LoadingErrorTitle = `${TextPathPrefix}.loadingErrorTitle`;
const LoadingErrorText = `${TextPathPrefix}.loadingErrorText`;
const LoadingErrorCheckLater = `${TextPathPrefix}.loadingErrorCheckLater`;
const ErrorLoading = () => (react_1.default.createElement(styled_1.ErrorBlock, null,
    react_1.default.createElement(styled_1.ErrorBody, null,
        react_1.default.createElement(alchemy_ui_1.NullZeroStateIcon, { size: "96", palette: 'expressiveNeutral', color: 'highlight', "aria-hidden": "true" }),
        react_1.default.createElement(styled_1.ErrorTitle, null, (0, utils_1.getSingleText)(LoadingErrorTitle)),
        react_1.default.createElement(styled_1.ErrorText, null, (0, utils_1.getSingleText)(LoadingErrorText)),
        react_1.default.createElement(styled_1.ErrorText, null, (0, utils_1.getSingleText)(LoadingErrorCheckLater)))));
const PageContent = ({ children }) => (react_1.default.createElement(styled_1.ScrollingContent, null,
    react_1.default.createElement(styled_1.FullPageContent, null, children)));
const triggerSuccessAlert = () => {
    (0, utils_1.getNgService)(($rootScope) => $rootScope.addAlert('success', (0, utils_1.getSingleText)(SaveNotification)), true);
};
const triggerErrorAlert = () => {
    (0, utils_1.getNgService)(($rootScope) => $rootScope.addAlert('danger', (0, utils_1.getSingleText)(DomainSaveError)), true);
};
const DomainsPage = ({ profile }) => {
    const urlGet = api_1.API.DOMAINS.FETCH.replace(api_1.PLACEHOLDER.PROPERTY_ID, profile.propertyId);
    const urlPost = api_1.API.DOMAINS.SAVE.replace(api_1.PLACEHOLDER.PROPERTY_ID, profile.propertyId);
    const [domainsSetup, setDomainsSetup] = (0, react_1.useState)({
        type: 'loading',
    });
    const [isDomainSetupChanged, setDomainListChanged] = (0, react_1.useState)(false); // for UI
    (0, react_1.useEffect)(() => {
        const fetchData = () => __awaiter(void 0, void 0, void 0, function* () {
            yield HttpManager_1.default.get(urlGet)
                .then((data) => {
                var _a, _b;
                setDomainsSetup({
                    type: 'loaded',
                    data: {
                        allDomainsAllowed: (_a = data === null || data === void 0 ? void 0 : data.allDomainsAllowed) !== null && _a !== void 0 ? _a : true,
                        allowedDomains: (_b = data === null || data === void 0 ? void 0 : data.allowedDomains) !== null && _b !== void 0 ? _b : [],
                    },
                });
            })
                .catch((e) => {
                setDomainsSetup({ type: 'error', code: e.status, errorMessage: e.error });
            });
        });
        fetchData();
    }, []);
    const setUnsavedChanges = (status) => {
        (0, utils_1.getNgService)(($rootScope) => $rootScope.unsavedChangesOnPage = status, true);
        setDomainListChanged(status);
    };
    const updateDomainsSetup = (0, react_1.useCallback)((data) => {
        if (domainsSetup != null && domainsSetup.type === 'loaded') {
            setDomainsSetup(Object.assign(Object.assign({}, domainsSetup), { data }));
            setUnsavedChanges(true);
        }
    }, [domainsSetup]);
    const saveDomains = (0, react_1.useCallback)(() => __awaiter(void 0, void 0, void 0, function* () {
        const data = domainsSetup.type === 'loaded' && domainsSetup.data;
        yield HttpManager_1.default.post(urlPost, data)
            .then(() => {
            triggerSuccessAlert();
            setUnsavedChanges(false);
        })
            .catch((e) => {
            console.error('Error: ', e);
            triggerErrorAlert();
        });
    }), [domainsSetup, profile]);
    const isSaveAllowed = () => isDomainSetupChanged
        && domainsSetup.type === 'loaded'
        && (domainsSetup.data.allDomainsAllowed || domainsSetup.data.allowedDomains.length);
    return (react_1.default.createElement(styled_1.Page, { id: "approved-domains-page" },
        react_1.default.createElement(styled_1.Row, null,
            react_1.default.createElement(styled_1.PageHeader, null, (0, utils_1.getSingleText)(Title)),
            react_1.default.createElement(styled_1.SaveButton, { disabled: !isSaveAllowed(), onClick: saveDomains },
                react_1.default.createElement("span", { className: "save-wrapper table-wrap" },
                    react_1.default.createElement("i", { className: "fa fa-save" }),
                    react_1.default.createElement("span", null, (0, utils_1.getSingleText)(Save))))),
        react_1.default.createElement(PageContent, null,
            react_1.default.createElement(LoadableBlock_1.LoadableBlock, { errorComponent: () => react_1.default.createElement(ErrorLoading, null), loaderStyles: { position: 'absolute' }, loaderSize: 60, data: domainsSetup, renderData: (data) => (react_1.default.createElement(DomainsConfiguration_1.DomainsConfiguration, { domainsSetup: data, updateDomainsSetup: updateDomainsSetup })) }))));
};
function mapStateToProps({ profile }) {
    return {
        profile,
    };
}
exports.default = (0, ProviderHoc_1.default)()((0, react_redux_1.connect)(mapStateToProps)(DomainsPage));
